export default {
  app: {
    tradeOffers: {
      country: 'Land',
      loginPrompt: 'För att se reseerbjudanden behöver du {0}.',
      logIn: 'logga in',
    },
  },
};
